import { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import axiosClient from "../axios";
import { useUser } from "../contexts/UserContext";
import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";

export default function LearnLayout() {
  const location = useLocation();
  const { user } = useUser();

  useEffect(() => {
    const pathSegments = location.pathname
      .split("/")
      .filter((segment) => segment.length > 0); // Filter out empty segments
    if (user && pathSegments.length === 4 && pathSegments[0] === "learn") {
      axiosClient
        .post("/api/save-learn-route", { route: location.pathname })
        .then((response) => {
          console.log("Route saved successfully", response);
        })
        .catch((error) => {
          console.error("Error saving route:", error);
        });
    }
  }, [location.pathname, user]);

  return (
    <div className="d-flex flex-column min-vh-100">
      <SiteHeader />

      <div className="flex-grow-1">
        <Outlet />
      </div>
      <SiteFooter />
    </div>
  );
}
